import icSupport from 'assets/img/ic_support_V2.png';
import icEmail from 'assets/img/ic_email_V2.png';
import icFacebook from 'assets/img/ic_facebook_V2.png';
import icTwitter from 'assets/img/ic_twitter_V2.png';
import icDiscord from 'assets/img/ic_discord_V2.png';
import icTelegram from 'assets/img/ic_telegram_V2.png';
import { navigateToHome } from 'src/utils/navigate';
export const menuList = [{
  name: 'Channel',
  children: [{
    key: 'Home',
    name: 'Home',
    handlePress: () => navigateToHome()
  }, {
    key: 'Thetan Arena',
    name: 'Thetan Arena',
    href: 'https://thetanarena.com/'
  }, {
    key: 'Blog',
    name: 'Blog',
    href: 'https://medium.com/@thetanarena'
  }, {
    key: 'FAQ',
    name: 'FAQ',
    href: 'https://wolffun.helpshift.com/hc/en/'
  }]
}, {
  name: 'Support',
  children: [{
    key: 'Instruction',
    name: 'Instruction',
    href: 'https://docs.google.com/presentation/d/173Jz9tGkWsbrV67GKxin3seJDxjQrEWR/edit#slide=id.p1'
  }, {
    key: 'Contact us',
    name: 'Contact us',
    href: 'mailto:marketing@thetanarena.com'
  }, {
    key: 'Support',
    name: 'Support',
    href: 'https://wolffun.helpshift.com/hc/en/3-thetan-arena/contact-us/'
  }]
}, {
  name: 'Info',
  children: [{
    key: 'About Wolffun',
    name: 'About Wolffun',
    href: 'https://www.wolffungame.com'
  }, {
    key: 'Policy',
    name: 'Policy',
    href: 'https://doc.thetanarena.com/faqs/policy'
  }, {
    key: 'Whitepaper',
    name: 'Whitepaper',
    href: 'https://doc.thetanarena.com/'
  }, {
    key: 'Audit report',
    name: 'Audit report',
    href: 'https://github.com/verichains/public-audit-reports/blob/main/Verichains%20Public%20Audit%20Report%20-%20ThetanArena%20-%20v1.2.pdf'
  }]
}];
export const parnershipLink = {
  label: 'Partnership Inquiry',
  chidren: [{
    label: 'Community/Business Partnership',
    email: 'mailto:bd@thetanarena.com',
    signup: 'https://docs.google.com/forms/d/e/1FAIpQLSeuGkmWg4O68l2YiLvWfa_B4LumoP77A-8Mqs8vrcESdSvXVQ/viewform'
  }, {
    label: 'Gaming Guild Application',
    email: 'mailto:bd@thetanarena.com',
    signup: 'https://docs.google.com/forms/d/e/1FAIpQLScYqIfTpqRiE0tGJKJRWj8jF4YRZY0w-JWQj0HGQP31rdxGgg/viewform'
  }, {
    label: 'Creator Program',
    email: 'mailto:marketing@thetanarena.com',
    signup: 'https://docs.google.com/forms/d/e/1FAIpQLSe6OLVWY47khuZfQrjMTp04U4YDq8YGxnmJvs8UoyI38-RQDg/viewform'
  }]
};
export const gameSupportLink = {
  label: 'Game Support Inquiry',
  children: [{
    label: 'Wolffun Helpshift',
    link: 'https://wolffun.helpshift.com/hc/en/',
    icon: icSupport
  }, {
    label: 'Discord - Game Support Channel',
    link: 'https://discord.com/login?redirect_to=/channels/871649660605984820/884308656605265971',
    icon: icSupport
  }, {
    label: 'Discord - Marketplace Support Channel',
    link: 'https://discord.com/login?redirect_to=/channels/871649660605984820/906216063853805568',
    icon: icSupport
  }, {
    label: 'Email Us',
    link: 'mailto:support@thetanarena.com',
    icon: icEmail
  }]
};
export const socialNetworkLink = [{
  icon: icFacebook,
  link: 'https://www.facebook.com/thetanarena'
}, {
  icon: icTwitter,
  link: 'https://twitter.com/thetan_world'
}, {
  icon: icDiscord,
  link: 'https://discord.gg/thetanworld'
}, {
  icon: icTelegram,
  link: 'https://t.me/thetanworldofficial'
}];